import { render, staticRenderFns } from "./DailyTasksKiko.vue?vue&type=template&id=b3cb8ac4&scoped=true"
import script from "./DailyTasksKiko.vue?vue&type=script&lang=js"
export * from "./DailyTasksKiko.vue?vue&type=script&lang=js"
import style0 from "./DailyTasksKiko.vue?vue&type=style&index=0&id=b3cb8ac4&lang=less&scoped=true"
import style1 from "./DailyTasksKiko.vue?vue&type=style&index=1&id=b3cb8ac4&lang=less&scoped=true"
import style2 from "./DailyTasksKiko.vue?vue&type=style&index=2&id=b3cb8ac4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cb8ac4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3cb8ac4')) {
      api.createRecord('b3cb8ac4', component.options)
    } else {
      api.reload('b3cb8ac4', component.options)
    }
    module.hot.accept("./DailyTasksKiko.vue?vue&type=template&id=b3cb8ac4&scoped=true", function () {
      api.rerender('b3cb8ac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P1_Girls/HostessTasks/components/DailyTasksKiko.vue"
export default component.exports